import React, { Component, lazy } from "react";
import { connect } from "react-redux";
import { withStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import Grow from '@material-ui/core/Grow';
import Fade from '@material-ui/core/Fade';
import TextField from '@material-ui/core/TextField';
import AccountCircle from '@material-ui/icons/AccountCircle';
import PhoneInTalkIcon from '@material-ui/icons/PhoneInTalk';
import RoomIcon from '@material-ui/icons/Room';
import HouseIcon from '@material-ui/icons/House';
import Collapse from '@material-ui/core/Collapse';
import CircularProgress from '@material-ui/core/CircularProgress';
import Backdrop from '@material-ui/core/Backdrop';
// import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import DirectionsIcon from '@material-ui/icons/Directions';
import IconButton from '@material-ui/core/IconButton';
import MailIcon from '@material-ui/icons/Mail';
import HomeIcon from '@material-ui/icons/Home';
import PlaceIcon from '@material-ui/icons/Place';
import CameraIcon from '@material-ui/icons/Camera';
import CropFreeIcon from '@material-ui/icons/CropFree';
import RestaurantIcon from '@material-ui/icons/Restaurant';
import RestaurantMenuIcon from '@material-ui/icons/RestaurantMenu';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MenuItem from '@material-ui/core/MenuItem';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import PieChartIcon from '@material-ui/icons/PieChart';
import { verifyTokenAndSession, closeScanModal, setCurrOpenedModal, setOrderModalState } from '../../../qr-scan/actions/scan.actions';
import OpenApp from "react-open-app";
import { setTermsDialogOpened, setPrivacyPolicyDialogOpened, setRefundDialogOpened } from '../../../menu/menu.actions';
import { Radio, RadioGroup, FormControl, FormLabel, FormHelperText } from '@material-ui/core';
import PaymentMethods from './common/PaymentMethods';
import TextFieldsIcon from '@material-ui/icons/TextFields';
// import OrderModalSpot from 'OrderModal/OMSpot';
// import OrderModalDelivery from 'OrderModal/OMDelivery';
// import OrderModalPreorder from 'OrderModal/OMPreorder';

import QrReader from "react-qr-reader";
import Utils from "../../../utils/Utils";
import Auth from "../../../utils/Auth";
import history from '../../../utils/history';

// import DeliveryAddressFieldGoogleMaps from './common/DeliveryAddressFieldGoogleMaps';
// import DeliveryAddressFieldGoogleMapsTest from './common/DeliveryAddressFieldtest';

// import DeliveryAddressFieldPlaces from './common/DeliveryAddressFieldPlaces';


import { styles } from '../styles/orderModal.styles';
import LunchSubscribeCheckbox from "./common/LunchSubscribeCheckbox";
import AccumulatedOrderAmount from "./common/AccumulatedOrderAmount";

const GoogleMapsDragMarker = lazy(() => import('./common/GoogleMapsDragMarker'));
const DeliveryAddressFieldPlaces = lazy(() => import('./common/DeliveryAddressFieldPlaces'));

class OMDelivery extends Component {

    constructor(props) {
        super(props);
        this.state = {
            mapModalOpen: false,
            mapLatitude: null,
            mapLongitude: null,
            mapCenter: null,
            mapKey: null
        };
    }

    handleOpenMapModal = () => {
        if (this.state.mapCenter && this.state.mapCenter.lat && this.state.mapCenter.lng) { } else {
            this.tryToGetLocation()
        }

        this.setState({
            mapModalOpen: true,
            mapCenter: { lat: this.state.mapLatitude, lng: this.state.mapLongitude }
        });
    };



    handleCloseMapModal = () => {
        this.setState({ mapModalOpen: false });
    };

    tryToGetLocation() {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const { latitude, longitude } = position.coords;
                console.log("GPS Location:", latitude, longitude);

                this.setState({
                    mapLatitude: latitude,
                    mapLongitude: longitude,
                    mapCenter: { lat: latitude, lng: longitude },
                    mapKey: Date.now()
                });

                this.props.onChangeParams("delivery_address_lat", latitude);
                this.props.onChangeParams("delivery_address_lng", longitude);
                this.reverseGeocode(latitude, longitude);
            },
            (error) => {
                console.error("Error getting initial location:", error.message);
            }
        );
    }

    componentDidMount() {
        const { settings } = this.props
        const payment_methods_for_order_types = Utils.getSettingsValue(settings, 'payment_methods_for_order_types') || {};

        if (!(payment_methods_for_order_types && this.props.currOpenedModal && payment_methods_for_order_types[this.props.currOpenedModal] && payment_methods_for_order_types[this.props.currOpenedModal].includes(this.props.omdata.payment_method))) {
            this.props.onChangeParams('payment_method', "")
        }

        if (settings && settings.use_google_location_coordinates && settings.use_google_location_coordinates.value && settings.use_google_location_coordinates.value == 1 && navigator.geolocation) {
            this.tryToGetLocation()
        } else {
            console.error("Geolocation is not supported by this browser.");
        }

    }

    reverseGeocode = (latitude, longitude) => {
        const apiKey = "AIzaSyAvKnQrp0hlgsTNclWEondG9A5uzK53kg8";
        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`;

        fetch(url)
            .then((response) => response.json())
            .then((data) => {
                if (data.results.length > 0) {
                    const address = data.results[0].formatted_address;
                    console.log("Address:", address);

                    // Записване на адреса в state
                    this.props.onChangeParams("address", address);
                }
            })
            .catch((error) => console.error("Error fetching address:", error));
    };

    handleLocationSelect = (latitude, longitude) => {
        console.log("New location selected:", latitude, longitude);

        this.setState({
            mapLatitude: latitude,
            mapLongitude: longitude
        });

        this.props.onChangeParams("delivery_address_lat", latitude);
        this.props.onChangeParams("delivery_address_lng", longitude);
        this.reverseGeocode(latitude, longitude);
    };


    resetToCurrentLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    console.log("Reset to Current Location:", latitude, longitude);

                    this.setState({
                        mapLatitude: latitude,
                        mapLongitude: longitude,
                        mapCenter: { lat: latitude, lng: longitude }, // ✅ Това ще принуди Google Maps да се обнови
                        mapKey: Date.now() // 🚀 Добавяме уникален ключ за форсиране на ререндер
                    });
                },
                (error) => {
                    console.error("Error getting location:", error.message);
                }
            );
        } else {
            console.error("Geolocation is not supported by this browser.");
        }
    };


    render() {
        const { classes, fullWidth = false, maxWidth = 'xs', open, onSubmit, onError, isLoadingOrder, orderTotal, settings, modalData, translations } = this.props;
        const default_currency_suffix = (settings.default_currency_suffix && settings.default_currency_suffix.value ? settings.default_currency_suffix.value : 'лв.')

        const payment_methods_for_order_types = Utils.getSettingsValue(settings, 'payment_methods_for_order_types') || {};

        let eachHoursCurrentDate = this.props.orderDates.find(p => p.value == (this.props.omdata.orderDate ? this.props.omdata.orderDate : this.props.defaultOrderDate))
        // console.log(`eachHoursCurrentDate`, eachHoursCurrentDate)
        if (eachHoursCurrentDate && eachHoursCurrentDate.eachDateHours) {
            eachHoursCurrentDate = eachHoursCurrentDate.eachDateHours
        } else {
            eachHoursCurrentDate = []
        }

        // console.log('this.state.mapCenter ', this.state.mapCenter)
        // console.log('this.state.mapCenter ', this.state.mapCenter)
        // console.log('this.state.mapLatitude', this.state.mapLatitude)
        // console.log('this.state.mapLongitude', this.state.mapLongitude)

        return (
            <React.Fragment>

                <Dialog
                    open={this.state.mapModalOpen}
                    onClose={this.handleCloseMapModal}
                >
                    <DialogTitle>Избери местоположение</DialogTitle>
                    <DialogContent>
                        {this.state.mapCenter && (
                            <GoogleMapsDragMarker
                                key={this.state.mapKey}
                                latitude={this.state.mapLatitude}
                                longitude={this.state.mapLongitude}
                                mapCenter={this.state.mapCenter}
                                onLocationSelect={this.handleLocationSelect}
                            />
                        )}

                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.resetToCurrentLocation}
                        >
                            Използвай текущата локация
                        </Button>
                        <Button
                            style={{ background: '#f66201', color: 'white' }}
                            variant="contained"
                            onClick={this.handleCloseMapModal}>Запази</Button>
                    </DialogActions>
                </Dialog>





                <Fade in={true} timeout={{ enter: 185, exit: 190 }}>
                    <DialogContentText>

                        <Collapse in={Object.keys(this.props.omdata.customErrors).length > 0 || (this.props.orderSent == 'false' && this.props.orderMessage.length != 0)} timeout="auto" unmountOnExit>
                            <p className={classes.errorContainer}>
                                {Object.keys(this.props.omdata.customErrors).length > 0 ? this.props.translations.messages.errors.invalid_fields : this.props.orderMessage}
                            </p>
                        </Collapse>

                        <span className={classes.textFieldContainer}>
                            <Grid container spacing={1} alignItems="flex-end" className={"no-padding"}>
                                <Grid item xs={1}>
                                    <AccountCircle />
                                </Grid>
                                <Grid item xs={11}>
                                    <TextField name="name" className={classes.textField}
                                        error={this.props.omdata.customErrors && this.props.omdata.customErrors.name} helperText={this.props.omdata.customErrors && this.props.omdata.customErrors.name ? this.props.omdata.customErrors.name : ''}
                                        label={translations.pages && translations.pages.cart_delivery ? translations.pages.cart_delivery.first_and_last_name : ''}
                                        value={this.props.omdata.name} onChange={(e) => this.props.onChange(e)}
                                    />
                                </Grid>
                            </Grid>
                        </span>

                        <span className={classes.textFieldContainer}>
                            <Grid container spacing={1} alignItems="flex-end" className={"no-padding"}>
                                <Grid item xs={1}>
                                    {Utils.getSettingsValue(settings, 'order_model_phone_placeholder') ?
                                        <TextFieldsIcon />
                                        :
                                        <PhoneInTalkIcon />
                                    }
                                </Grid>
                                <Grid item xs={11}>
                                    <TextField
                                        name="phone"
                                        type={Utils.getSettingsValue(settings, 'order_model_phone_placeholder') ? "text" : "tel"}
                                        className={classes.textField}
                                        error={this.props.omdata.customErrors && (this.props.omdata.customErrors.phone || this.props.omdata.customErrors.invalid_phone_field) ? ((Utils.getSettingsValue(settings, 'order_model_phone_placeholder')) ? this.props.omdata.customErrors.invalid_phone_field : this.props.omdata.customErrors.phone) : ''}
                                        helperText={this.props.omdata.customErrors && (this.props.omdata.customErrors.phone || this.props.omdata.customErrors.invalid_phone_field) ? ((Utils.getSettingsValue(settings, 'order_model_phone_placeholder')) ? this.props.omdata.customErrors.invalid_phone_field : this.props.omdata.customErrors.phone) : ''}
                                        label={Utils.getSettingsValue(settings, 'order_model_phone_placeholder') ? Utils.getSettingsValue(settings, 'order_model_phone_placeholder') : (translations.pages && translations.pages.cart_delivery ? translations.pages.cart_delivery.phone : '')}
                                        value={this.props.omdata.phone} onChange={(e) => this.props.onChange(e)}
                                    />
                                </Grid>
                            </Grid>
                        </span>


                        {Utils.getSettingsValue(settings, 'use_google_location_coordinates') == 1 ?
                            <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "10px" }}>
                                <Button
                                    style={{ background: '#f66201', color: 'white' }}
                                    variant="contained"
                                    onClick={this.handleOpenMapModal}
                                >
                                    {this.state.mapCenter && this.state.mapCenter.lat && this.state.mapCenter.lng ? 'Промени' : 'Избери'} местоположение
                                </Button>
                                {this.state.mapCenter && this.state.mapCenter.lat && this.state.mapCenter.lng ?
                                    <div style={{ textAlign: 'center', fontSize: 'small' }}>
                                        Координати: {this.state.mapLatitude} , {this.state.mapLongitude}
                                    </div>
                                    :
                                    null
                                }
                            </div>
                            :
                            null
                        }


                        {/* GOOGLE MAPS ADDRESS FIELD */}
                        {Utils.getDeliveryRadiuses() != null || Utils.getDeliveryShapes() != null ?
                            <>
                                {
                                    (Utils.getSettingsValue(settings, 'use_google_location_coordinates') == 1 && (this.state.mapCenter == null || (this.state.mapCenter && this.state.mapCenter.lat == null && this.state.mapCenter.lng == null)))
                                        || (Utils.getSettingsValue(settings, 'use_google_location_coordinates') == 0 && (Utils.getDeliveryRadiuses() != null || Utils.getDeliveryShapes() != null)) ?
                                        <span className={classes.textFieldContainer}>
                                            <Grid container spacing={1} alignItems="flex-end" className={"no-padding"}>
                                                <Grid item xs={1}>
                                                    <RoomIcon />
                                                </Grid>
                                                <Grid item xs={11}>
                                                    {/* <DeliveryAddressFieldGoogleMaps /> */}
                                                    {/* <DeliveryAddressFieldGoogleMapsTest /> */}
                                                    <DeliveryAddressFieldPlaces
                                                        onChangeParams={this.props.onChangeParams}
                                                        addressValue={this.props.omdata.address}
                                                        addressOnChange={(e) => this.props.onChange(e)}
                                                        onError={this.props.onError}
                                                        omdata={this.props.omdata}
                                                        classes={this.props.classes}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </span>
                                        :
                                        null
                                }
                                <span className={classes.textFieldContainer}>
                                    <Grid container spacing={1} alignItems="flex-end" gap={1} >
                                        <Grid item xs={1}> <HouseIcon /> </Grid>
                                        <Grid item xs={3}>
                                            <TextField name="streetNumber" type="text" className={classes.textField}
                                                error={this.props.omdata.customErrors && this.props.omdata.customErrors.streetNumber} helperText={this.props.omdata.customErrors && this.props.omdata.customErrors.streetNumber ? this.props.omdata.customErrors.streetNumber : ''}
                                                label={translations.pages && translations.pages.cart_delivery ? translations.pages.cart_delivery.street_number_short : "№/Бл."}
                                                value={this.props.omdata.streetNumber}
                                                onChange={(e) => this.props.onChange(e)}
                                            />
                                        </Grid>
                                        {/* <Grid item xs={1}></Grid> */}
                                        <Grid item xs={2}>
                                            <TextField name="floorNumber" type="text" className={classes.textField}
                                                error={this.props.omdata.customErrors && this.props.omdata.customErrors.floorNumber} helperText={this.props.omdata.customErrors && this.props.omdata.customErrors.floorNumber ? this.props.omdata.customErrors.floorNumber : ''}
                                                label={translations.pages && translations.pages.cart_delivery ? translations.pages.cart_delivery.floor_short : "Ет."}
                                                value={this.props.omdata.floorNumber}
                                                onChange={(e) => this.props.onChange(e)}
                                            />
                                        </Grid>
                                        {/* <Grid item xs={1}>  </Grid> */}
                                        <Grid item xs={2}>
                                            <TextField name="apNumber" type="text" className={classes.textField}
                                                error={this.props.omdata.customErrors && this.props.omdata.customErrors.apNumber} helperText={this.props.omdata.customErrors && this.props.omdata.customErrors.apNumber ? this.props.omdata.customErrors.apNumber : ''}
                                                label={translations.pages && translations.pages.cart_delivery ? translations.pages.cart_delivery.appartment_short : "Aп."}
                                                value={this.props.omdata.apNumber}
                                                onChange={(e) => this.props.onChange(e)}
                                            />
                                        </Grid>
                                        {/* <Grid item xs={1}>  </Grid> */}
                                        <Grid item xs={2}>
                                            <TextField name="bellNumber" type="text" className={classes.textField}
                                                error={this.props.omdata.customErrors && this.props.omdata.customErrors.bellNumber} helperText={this.props.omdata.customErrors && this.props.omdata.customErrors.bellNumber ? this.props.omdata.customErrors.bellNumber : ''}
                                                label={translations.pages && translations.pages.cart_delivery ? translations.pages.cart_delivery.bell_short : "Зв."}
                                                value={this.props.omdata.bellNumber}
                                                onChange={(e) => this.props.onChange(e)}
                                            />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <TextField name="entranceNumber" type="text" className={classes.textField}
                                                error={this.props.omdata.customErrors && this.props.omdata.customErrors.entranceNumber} helperText={this.props.omdata.customErrors && this.props.omdata.customErrors.entranceNumber ? this.props.omdata.customErrors.entranceNumber : ''}
                                                label={translations.pages && translations.pages.cart_delivery ? translations.pages.cart_delivery.entrance_short : "Вх."}
                                                value={this.props.omdata.entranceNumber}
                                                onChange={(e) => this.props.onChange(e)}
                                            />
                                        </Grid>
                                    </Grid>
                                </span>
                            </>
                            :
                            <>
                                {(Utils.getSettingsValue(settings, 'use_google_location_coordinates') == 1 && (this.state.mapCenter == null || (this.state.mapCenter && this.state.mapCenter.lat == null && this.state.mapCenter.lng == null)) || (Utils.getSettingsValue(settings, 'use_google_location_coordinates') == 0)) ?
                                    <span className={classes.textFieldContainer}>
                                        <Grid container spacing={1} alignItems="flex-end" className={"no-padding"}>
                                            <Grid item xs={1}>
                                                {Utils.getSettingsValue(settings, 'order_model_address_placeholder') ?
                                                    <TextFieldsIcon />
                                                    :
                                                    <RoomIcon />
                                                }
                                            </Grid>
                                            <Grid item xs={11}>
                                                <TextField name="address" className={classes.textField}
                                                    error={this.props.omdata.customErrors && (this.props.omdata.customErrors.address || this.props.omdata.customErrors.invalid_address_field) ? ((Utils.getSettingsValue(settings, 'order_model_address_placeholder')) ? this.props.omdata.customErrors.invalid_address_field : this.props.omdata.customErrors.address) : ''}
                                                    helperText={this.props.omdata.customErrors && (this.props.omdata.customErrors.address || this.props.omdata.customErrors.invalid_address_field) ? ((Utils.getSettingsValue(settings, 'order_model_address_placeholder')) ? this.props.omdata.customErrors.invalid_address_field : this.props.omdata.customErrors.address) : ''}
                                                    label={Utils.getSettingsValue(settings, 'order_model_address_placeholder') ? Utils.getSettingsValue(settings, 'order_model_address_placeholder') : (translations.pages && translations.pages.cart_delivery ? translations.pages.cart_delivery.order_address : '')}
                                                    value={this.props.omdata.address} onChange={(e) => this.props.onChange(e)}
                                                />
                                            </Grid>
                                        </Grid>
                                    </span>
                                    :
                                    null
                                }
                            </>
                        }



                        {settings.order_email_visible && settings.order_email_visible.value && settings.order_email_visible.value == 1 ?
                            <span className={classes.textFieldContainer}>
                                <Grid container spacing={1} alignItems="flex-end" className={"no-padding"}>
                                    <Grid item xs={1}>
                                        <MailIcon />
                                    </Grid>
                                    <Grid item xs={11}>
                                        <TextField name="email" type="email" className={classes.textField}
                                            error={this.props.omdata.customErrors && this.props.omdata.customErrors.email} helperText={this.props.omdata.customErrors && this.props.omdata.customErrors.email ? this.props.omdata.customErrors.email : ''}
                                            label={translations.pages && translations.pages.cart_delivery ? translations.pages.cart_delivery.email : ''}
                                            value={this.props.omdata.email} onChange={(e) => this.props.onChange(e)}
                                        />
                                    </Grid>
                                </Grid>
                            </span>
                            :
                            null
                        }

                        {/* ----------------------- REGIONS ----------------------- */}
                        {/* GOOGLE maps address is with priority */}
                        {this.props.regions.length > 0 && Utils.getDeliveryRadiuses() == null && Utils.getDeliveryShapes() == null ?
                            <span className={classes.textFieldContainer}>
                                <Grid container spacing={1} alignItems="flex-end" className={"no-padding"}>
                                    <Grid item xs={1}>
                                        <PieChartIcon />
                                    </Grid>
                                    <Grid item xs={11}>

                                        <TextField select name="regionId" className={classes.textField}
                                            error={this.props.omdata.customErrors && this.props.omdata.customErrors.regionId} helperText={this.props.omdata.customErrors && this.props.omdata.customErrors.regionId ? this.props.omdata.customErrors.regionId : ''}
                                            label={translations.pages && translations.pages.cart_delivery ? translations.pages.cart_delivery.region : ''}
                                            value={this.props.omdata.regionId ? this.props.omdata.regionId : ''} onChange={(e) => this.props.onChange(e)}
                                        >
                                            {this.props.regions.sort(Utils.sortName()).map((option) => (
                                                <MenuItem key={option.id} value={option.id} selected>
                                                    {option.name} {option.delivery_price == '0.00' || Object.keys(this.props.orderTypePrice).length > 0 ? null : ('- ' + option.delivery_price + ' ' + default_currency_suffix)}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                </Grid>
                            </span>
                            :
                            null
                        }

                        {/* 
                        {payment_methods_for_order_types && payment_methods_for_order_types.delivery ?
                            <span className={clsx(classes.textFieldContainer, classes.paymentMethodContainer)}>
                                <FormControl component="fieldset" error={this.props.omdata.customErrors && this.props.omdata.customErrors.payment_method} >
                                    <FormLabel component="legend" className={classes.orderLabel}>{translations.pages.cart_delivery && translations.pages.cart_delivery.payment_type_delivery ? translations.pages.cart_delivery.payment_type_delivery : ''}</FormLabel>
                                    <RadioGroup row aria-label="position" name="payment_method" defaultValue={this.props.omdata.payment_method}> 
                                        {payment_methods_for_order_types.delivery.map(p =>
                                            <FormControlLabel
                                                value={p}
                                                control={<Radio className={classes.orderRadio} onClick={(e) => this.props.onChange(e)} />}
                                                label={translations.pages.cart_delivery && translations.pages.cart_delivery['payment_' + p] ? translations.pages.cart_delivery['payment_' + p] : ''}
                                                labelPlacement={p}
                                            />
                                        )}
                                    </RadioGroup>
                                    {this.props.omdata.payment_method === 'epay' ? 
                                        <React.Fragment>
                                            <RadioGroup row aria-label="position" name="payment_instrument" defaultValue={this.props.omdata.payment_instrument}>
                                                {Auth.getDecodedUser().payment_instruments.map(pi => (
                                                    <FormControlLabel
                                                        value={pi.id}
                                                        control={<Radio className={classes.orderRadio} onClick={(e) => this.props.onChange(e)} />}
                                                        label={pi.name}
                                                        labelPlacement={pi.name}
                                                    />
                                                ))}
                                            </RadioGroup>
                                        </React.Fragment>
                                    :
                                        null
                                    }
                                    <FormHelperText>{this.props.omdata.customErrors && this.props.omdata.customErrors.payment_method ? this.props.omdata.customErrors.payment_method : ''}</FormHelperText>
                                </FormControl>
                            </span>
                            :
                            null
                        } */}

                        {Utils.getSettingsValue(settings, 'hide_order_delivery_pickup_date') != '1' ?
                            <React.Fragment>
                                <b style={{
                                    marginTop: 25,
                                    display: 'block'
                                }}
                                >{translations.pages && translations.pages.cart_delivery ? translations.pages.cart_delivery.delivery_time : ''}:</b>

                                <div className={classes.orderTimeOptionsContainer}>

                                    <TextField select name="orderDate" className={classes.textField}
                                        error={this.props.omdata.customErrors && this.props.omdata.customErrors.orderDate} helperText={this.props.omdata.customErrors && this.props.omdata.customErrors.orderDate ? this.props.omdata.customErrors.orderDate : ''}
                                        value={this.props.omdata.orderDate ? this.props.omdata.orderDate : this.props.defaultOrderDate} onChange={(e) => this.props.onChange(e)}
                                    >
                                        {this.props.orderDates.map((option) =>
                                            (option && option.eachDateHours && Object.values(option.eachDateHours).length > 0) ?
                                                <MenuItem key={option.value} value={option.value} selected>
                                                    {option.label}
                                                </MenuItem>
                                                :
                                                null
                                        )}
                                    </TextField>

                                    <TextField select name="orderTime" className={classes.textField}
                                        error={this.props.omdata.customErrors && this.props.omdata.customErrors.orderTime} helperText={this.props.omdata.customErrors && this.props.omdata.customErrors.orderTime ? this.props.omdata.customErrors.orderTime : ''}
                                        value={this.props.omdata.orderTime ?
                                            (
                                                ((Utils.getSettingsValue(settings, 'enable_showing_diapasone_in_times_for_delivery_or_pickup_in_order_modal') == '1') && (this.props.omdata.orderTime.indexOf(' - ') !== -1)) ?
                                                    this.props.omdata.orderTime.split(" - ")[0] :
                                                    this.props.omdata.orderTime
                                            ) :
                                            // this.props.defaultOrderTime
                                            ((Utils.getSettingsValue(settings, 'enable_showing_diapasone_in_times_for_delivery_or_pickup_in_order_modal') == '1') && (this.props.defaultOrderTime.indexOf(' - ') !== -1)) ?
                                                this.props.defaultOrderTime.split(" - ")[0] :
                                                this.props.defaultOrderTime

                                        }
                                        onChange={(e) => this.props.onChange(e)}
                                    >
                                        {eachHoursCurrentDate.map((option) => (
                                            <MenuItem key={option}
                                                value={
                                                    Utils.getSettingsValue(settings, 'enable_showing_diapasone_in_times_for_delivery_or_pickup_in_order_modal') == '1' && option.indexOf(' - ') !== -1 ?
                                                        option.split(" - ")[0]
                                                        :
                                                        option
                                                }>
                                                {option}
                                            </MenuItem>
                                        ))}
                                    </TextField>

                                </div>
                            </React.Fragment>
                            :
                            null
                        }


                        <TextField
                            error={this.props.omdata.customErrors && this.props.omdata.customErrors.text_comment} helperText={this.props.omdata.customErrors && this.props.omdata.customErrors.text_comment ? this.props.omdata.customErrors.text_comment : ''}
                            style={{ marginTop: 10 }}
                            id="standard-multiline-static"
                            label={translations.common && translations.common.order_comment ? translations.common.order_comment : ''}
                            multiline
                            rows="2"
                            name="orderTextComment"
                            value={this.props.omdata.orderTextComment}
                            onChange={(e) => this.props.onChange(e)}
                            className={classes.textField}
                        />

                        {Utils.getSettingsValue(settings, 'show_cutlery_option_on_making_delivery_order') == '1' && Utils.getSettingsValue(settings, 'additional_price_each_cutlery') && Utils.getSettingsValue(settings, 'additional_price_each_cutlery') != '0' ?

                            <span className={clsx(classes.textFieldContainer, classes.cutleryOptionContainer)}>
                                <FormControl style={{ width: '100%' }} component="fieldset" error={this.props.omdata.customErrors && this.props.omdata.customErrors.cutlery} >
                                    <FormLabel component="legend" className={classes.orderLabel}>{translations.pages.cart_delivery && translations.pages.cart_delivery.how_many_cutlery_needed ? translations.pages.cart_delivery.how_many_cutlery_needed : ''}</FormLabel>

                                    <Grid container spacing={1} alignItems="flex-end" className={"no-padding"} style={{ marginTop: 10 }}>
                                        <Grid item xs={2}>
                                            <Button style={{ background: '#ddd' }} onClick={() => this.props.setCutleryItemsCount(parseInt(this.props.omdata.count_cutlery <= 0 ? 1 : this.props.omdata.count_cutlery) - 1)} >-</Button>
                                        </Grid>

                                        <Grid item xs={8}>
                                            <TextField name="count_cutlery" className={clsx(classes.textField, classes.textFieldCentered)}
                                                // error={this.props.omdata.customErrors && this.props.omdata.customErrors.name} 
                                                // helperText={this.props.omdata.customErrors && this.props.omdata.customErrors.name ? this.props.omdata.customErrors.name : ''}
                                                // label={translations.pages && translations.pages.cart_delivery ? translations.pages.cart_delivery.first_and_last_name : ''}
                                                value={parseInt(this.props.omdata.count_cutlery)} onChange={(e) => this.props.onChange(e)} inputProps={{ min: 0, max: 20 }}
                                            />
                                        </Grid>

                                        <Grid item xs={2}>
                                            <Button style={{ background: '#ddd' }} onClick={() => this.props.setCutleryItemsCount(parseInt(this.props.omdata.count_cutlery >= 20 ? 19 : this.props.omdata.count_cutlery) + 1)} >+</Button>
                                        </Grid>

                                    </Grid>

                                    <FormHelperText>{this.props.omdata.customErrors && this.props.omdata.customErrors.cutlery ? this.props.omdata.customErrors.cutlery : ''}</FormHelperText>
                                </FormControl>
                            </span>


                            : (Utils.getSettingsValue(settings, 'show_cutlery_option_on_making_delivery_order') == '1' ?
                                <span className={clsx(classes.textFieldContainer, classes.cutleryOptionContainer)}>
                                    <FormControl component="fieldset" error={this.props.omdata.customErrors && this.props.omdata.customErrors.cutlery} >
                                        <FormLabel component="legend" className={classes.orderLabel}>{translations.pages.cart_delivery && translations.pages.cart_delivery.cutlery_needed ? translations.pages.cart_delivery.cutlery_needed : ''}</FormLabel>
                                        <RadioGroup row aria-label="position" name="cutlery" value={this.props.omdata.cutlery}> {/* defaultValue="1" */}
                                            <FormControlLabel
                                                value="1"
                                                control={<Radio className={classes.orderRadio} onClick={(e) => this.props.onChange(e)} />}
                                                label={translations.pages.cart_delivery && translations.pages.cart_delivery.cutlery_needed_yes ? translations.pages.cart_delivery.cutlery_needed_yes : ''}
                                                labelPlacement="1"
                                            />
                                            <FormControlLabel
                                                value="0"
                                                control={<Radio className={classes.orderRadio} onClick={(e) => this.props.onChange(e)} />}
                                                label={translations.pages.cart_delivery && translations.pages.cart_delivery.cutlery_needed_no ? translations.pages.cart_delivery.cutlery_needed_no : ''}
                                                labelPlacement="0"
                                            />
                                        </RadioGroup>
                                        <FormHelperText>{this.props.omdata.customErrors && this.props.omdata.customErrors.cutlery ? this.props.omdata.customErrors.cutlery : ''}</FormHelperText>
                                    </FormControl>
                                </span>
                                :
                                null
                            )
                        }



                        {payment_methods_for_order_types && payment_methods_for_order_types.delivery && Object.values(payment_methods_for_order_types.delivery).length > 0
                            ?
                            <PaymentMethods
                                paymentMethods={payment_methods_for_order_types && payment_methods_for_order_types.delivery || []}
                                omdata={this.props.omdata}
                                onChange={this.props.onChange}
                                classes={classes}
                                currentOrderType={this.props.currentOrderType}
                                submitOrder={this.props.submitOrder}
                            />
                            :
                            null
                        }

                        <p style={{ fontSize: 13, margin: 0, marginTop: '13px !important' }}>
                            {translations.common && translations.common.order_modal_agree_with ? translations.common.order_modal_agree_with : ''}
                            <Button onClick={() => this.props.setTermsDialogOpened(true)} className={clsx(classes.formButtons, "underlined")} disableRipple>{translations.common && translations.common.terms_for_use ? translations.common.terms_for_use : ''}</Button>
                            {translations.common && translations.common.and ? translations.common.and : ''} <Button onClick={() => this.props.setPrivacyPolicyDialogOpened(true)} className={clsx(classes.formButtons, "underlined")} disableRipple>{translations.common && translations.common.privacy_policy ? translations.common.privacy_policy : ''}</Button>
                            {payment_methods_for_order_types && payment_methods_for_order_types.delivery && payment_methods_for_order_types.delivery.find(p => p == 'online') ?
                                <React.Fragment>
                                    {translations.common && translations.common.and ? translations.common.and : ''} <Button onClick={() => this.props.setRefundDialogOpened(true)} className={clsx(classes.formButtons, "underlined")} disableRipple>{translations.common && translations.common.refund_policy ? translations.common.refund_policy : ''}</Button>
                                </React.Fragment>
                                :
                                null
                            }
                        </p>

                        {/* <FormControlLabel
                            className="privacy-policy-checkbox"
                            control={
                                <Checkbox
                                    name="privacy_policy"
                                    className={classes.orderCheckbox}
                                    onClick={e => this.props.onChangeCheckbox(e)}
                                />
                            }
                            label={<React.Fragment>Запознах се и съм съгласен с  и <Button onClick={() => this.props.setTermsDialogOpened(true)} className={clsx(classes.formButtons, "underlined")}>Условията за ползване</Button></React.Fragment>}
                        />
                        <FormHelperText style={{ color: '#f44336' }}>{this.props.omdata.customErrors && this.props.omdata.customErrors.privacy_policy ? this.props.omdata.customErrors.privacy_policy : ''}</FormHelperText> */}


                        <span className={clsx(classes.textFieldContainer, classes.buttonsRow)} style={{ margin: 0 }}>
                            <FormControlLabel
                                style={{ marginRight: 0 }}
                                control={
                                    <Checkbox
                                        name="rememberMe"
                                        className={classes.orderCheckbox}
                                        defaultChecked={this.props.omdata.rememberMe}
                                        onChange={e => this.props.onChangeCheckbox(e)}
                                    />
                                }
                                label={translations.pages && translations.pages.cart_delivery ? translations.pages.cart_delivery.remember_me : ''}
                            />

                            <LunchSubscribeCheckbox
                                classes={classes}
                                onChange={this.props.onChange}
                                onChangeCheckbox={this.props.onChangeCheckbox}
                                onChangeParams={this.props.onChangeParams}
                                omdata={this.props.omdata}
                                settings={settings}
                            />

                            {settings.promocode_visible && settings.promocode_visible.value && settings.promocode_visible.value == 1 ?
                                <Button
                                    onClick={() => this.props.onClick('inputPromoCodeVisible', !this.props.omdata.inputPromoCodeVisible)}
                                    className={classes.promoCodeBtn}
                                    endIcon={this.props.omdata.inputPromoCodeVisible ? <KeyboardArrowDownIcon /> : <KeyboardArrowLeftIcon />}
                                >
                                    {translations.pages && translations.pages.cart_delivery ? translations.pages.cart_delivery.promo_code : ''}
                                </Button>
                                :
                                null
                            }
                        </span>


                        {settings.promocode_visible && settings.promocode_visible.value && settings.promocode_visible.value == 1 ?
                            <div className={clsx(classes.textFieldContainer, classes.promoCodeRow)}>
                                <Collapse in={this.props.omdata.inputPromoCodeVisible} timeout="auto" unmountOnExit>
                                    <Grid container alignItems="flex-end" className={"no-padding"} style={{ width: '100%', minWidth: 200 }}>
                                        <Grid item xs={8}>
                                            <TextField name="promoCode" label={translations.pages && translations.pages.cart_delivery ? translations.pages.cart_delivery.promo_code_placeholder : ''} value={this.props.omdata.promoCode} onChange={(e) => this.props.onChange(e)}
                                                className={this.props.promocodeData && this.props.promocodeData.payload && this.props.promocodeData.payload.found ? clsx(classes.promocodeAppliedSuccess, classes.textField) : (this.props.promocodeData && this.props.promocodeData.payload && this.props.promocodeData.payload.found == false ? clsx(classes.textField, classes.promocodeAppliedFail) : classes.textField)}
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Button
                                                onClick={this.props.applyPromocode}
                                                className={classes.applyPromoCodeBtn}
                                            >
                                                {translations.pages && translations.pages.cart_delivery ? translations.pages.cart_delivery.apply : ''}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Collapse>
                            </div>
                            :
                            null
                        }

                        {settings.required_checkbox_in_order_modal && settings.required_checkbox_in_order_modal.value && settings.required_checkbox_in_order_modal.value.length > 0 ?
                            <FormControl component="fieldset" error={this.props.omdata.customErrors && this.props.omdata.customErrors.required_checkbox_in_order_modal} >
                                <FormControlLabel
                                    style={{ marginRight: 0 }}
                                    control={
                                        <Checkbox
                                            name="required_checkbox_in_order_modal"
                                            defaultChecked={this.props.omdata.required_checkbox_in_order_modal}
                                            className={classes.orderCheckbox}
                                            onChange={e => this.props.onChangeCheckbox(e)}
                                        />
                                    }
                                    label={<div dangerouslySetInnerHTML={{ __html: settings.required_checkbox_in_order_modal.value }}></div>}
                                />
                                <FormHelperText>{this.props.omdata.customErrors && this.props.omdata.customErrors.required_checkbox_in_order_modal ? this.props.omdata.customErrors.required_checkbox_in_order_modal : ''}</FormHelperText>
                            </FormControl>
                            :
                            null
                        }

                        {settings.required_checkbox_in_order_modal_2 && settings.required_checkbox_in_order_modal_2.value && settings.required_checkbox_in_order_modal_2.value.length > 0 ?
                            <FormControl component="fieldset" error={this.props.omdata.customErrors && this.props.omdata.customErrors.required_checkbox_in_order_modal_2} >
                                <FormControlLabel
                                    style={{ marginRight: 0 }}
                                    control={
                                        <Checkbox
                                            name="required_checkbox_in_order_modal_2"
                                            defaultChecked={this.props.omdata.required_checkbox_in_order_modal_2}
                                            className={classes.orderCheckbox}
                                            onChange={e => this.props.onChangeCheckbox(e)}
                                        />
                                    }
                                    label={<div dangerouslySetInnerHTML={{ __html: settings.required_checkbox_in_order_modal_2.value }}></div>}
                                />
                                <FormHelperText>{this.props.omdata.customErrors && this.props.omdata.customErrors.required_checkbox_in_order_modal_2 ? this.props.omdata.customErrors.required_checkbox_in_order_modal_2 : ''}</FormHelperText>
                            </FormControl>
                            :
                            null
                        }

                        <AccumulatedOrderAmount
                            onChangeParams={this.props.onChangeParams}
                            accumulatedOrderAmountUsed={this.props.omdata.accumulatedOrderAmountUsed}
                            finalPrice={this.props.finalPrice}
                        />

                    </DialogContentText>
                </Fade>

            </React.Fragment >
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let chosenPlaceOrderTypes = [];
    let chosenPlaceId = state.places.chosen_place;
    let chosenPlace = state.places.places.filter(p => p.id == chosenPlaceId);
    if (chosenPlace.length == 0) {
        chosenPlace = null;
    } else {
        chosenPlace = chosenPlace[0];
        chosenPlaceOrderTypes = chosenPlace.ordertypes;
    }

    return {
        isLoadingOrder: state.products.isLoadingOrder || false,
        settings: state.settings.settings || [],
        scan_modal_open: state.scan.scan_modal_open || 0,
        currOpenedModal: state.scan.curr_opened_modal || 'multiple',
        places: state.places.places || [],
        chosenPlace: chosenPlace,
        chosenPlaceOrderTypes: chosenPlaceOrderTypes,
        regions: state.regions.regions || [],
        productsToOrder: Utils.normalizeCartProducts(state.products.to_order) || [],
        productIngredients: state.products.productIngredients || [],
        translations: state.lang.translations,
    };
};

export default withStyles(styles)(connect(mapStateToProps, { verifyTokenAndSession, closeScanModal, setCurrOpenedModal, setOrderModalState, setTermsDialogOpened, setPrivacyPolicyDialogOpened, setRefundDialogOpened })(OMDelivery));